import React, { useState } from 'react';
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin,
  FaFacebook,
  FaLinkedinIn,
} from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import logo from '../assets/logo.jpg';
import { Link } from 'react-scroll';
import ReactDOM from "react-dom";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#ccd6f6] text-black border-b border-black shadow-lg'>
      <div className=" h-">
        <img src={logo} alt='Logo Image' style={{ width: '50px' }} />
      </div>
     

      {/* menu */}
      <ul className='hidden md:flex'>
        <li className=" hover:text-pink-600 text-bold">
          <a href='/home' smooth={true} duration={50000000}>
            Home
          </a>
        </li>
        <li className=" hover:text-pink-600 text-bold">
          <a href='/About' smooth={true} duration={0}>
            About
          </a>
        </li>
        <li className=" hover:text-pink-600 text-bold">
        <a href ='/blogs' smooth={true} duration={500}>
            Blogs
            </a>
        </li > 
        <li className=" hover:text-pink-600 text-bold">
           <a href ='/work' smooth={true} duration={500}>
            Work
            </a>
        </li>
        <li className=" hover:text-pink-600 text-bold">
          <Link to='contact' smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-10'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center'
        }
      >
        <li className='py-6 text-4xl'>
        <a href='/home' smooth={true} duration={500}>
            Home
          </a>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <a href='/About' smooth={true} duration={500}>
            About
          </a>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <a href='/Skills' smooth={true} duration={500}>
            Skills
          </a>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <a href='/Work' smooth={true} duration={500}>
            Work
          </a>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='contact' smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Social icons */}
      <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='/'
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='/https://www.linkedin.com/in/anisha-ghosh-189ab4229'
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='/https://github.com/Anisha100'
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='/'
            >
              Resume <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
